import { UserPreferenceKeys } from '@common/preferences/types';
import { useUserPreference } from '@common/preferences/userPreference';
import { Entity } from '@common/types/Entity';
import { EntityEvents } from '@common/user-analytics';
import { ArrowNarrowRightIcon, LightbulbBIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Button, Card, RadialIconContainer, Stack, Text } from '@prophecy/ui-v3';
import React from 'react';
import styled from 'styled-components';

import { useMixPanel } from '../../../../context/mixpanel/context';
import { replayToken } from '../../../../utils/replayToken';

const StyledButton = styled(Button)`
  color: ${theme.colors.gray600};
` as unknown as typeof Button;
const StyledCard = styled(Card)`
  border: 1px solid ${theme.colors.gray100};
  width: 100%;
  margin: ${theme.spaces.x16} 0;
`;

export const ResumeReplayBanner = () => {
  const [replayData, setReplayPreference] = useUserPreference(UserPreferenceKeys.replay);
  const { track } = useMixPanel();
  if (!replayData?.shareLink || replayToken.hasDirectAccess) {
    return null;
  }
  const currentStep = replayData?.step !== undefined ? replayData.step + 1 : 1;
  const navigateToIDEURL = () => {
    track(EntityEvents[Entity.Pipeline].ide.replayOnboardingResume, {
      name: replayData?.shareLink,
      step: replayData?.step
    });
    window.location.href = replayData?.shareLink as string;
  };

  const resetPreference = () => {
    track(EntityEvents[Entity.Pipeline].ide.replayStopResumeNotification, {
      name: replayData?.shareLink,
      step: replayData?.step
    });
    setReplayPreference(null);
  };
  return (
    <StyledCard hasHoverEffect={false}>
      <Stack direction='horizontal' gap={theme.spaces.x16} width='100%' alignY='center' align='space-between'>
        <Stack direction='horizontal' gap={theme.spaces.x16}>
          <RadialIconContainer gradient={false} tone='brand'>
            <div>
              <LightbulbBIcon type='default' color={theme.colors.brand600} />
            </div>
          </RadialIconContainer>
          <Stack gap={theme.spaces.x12}>
            <Text level='sm' tone={theme.colors.gray700}>
              Just a reminder: you haven’t finished your replay session
            </Text>
            <Text level='sm' tone={theme.colors.gray600}>
              You stopped at step {currentStep}. Resume now to complete the remaining steps.
            </Text>
          </Stack>
        </Stack>
        <Stack direction='horizontal' gap={theme.spaces.x16}>
          <StyledButton onClick={resetPreference} variant='link' data-test-id='dont-notify-replay'>
            Don’t notify again
          </StyledButton>
          <Button
            data-test-id='resume-replay'
            onClick={navigateToIDEURL}
            icon={<ArrowNarrowRightIcon type='default' />}>
            Resume Replay
          </Button>
        </Stack>
      </Stack>
    </StyledCard>
  );
};
